import React from 'react';

const FeatureContext = React.createContext({
    categories: [],
    featuresData: {
        featureSelection: [],
    },
});

export const FeatureProvider = FeatureContext.Provider;
export const FeatureConsumer = FeatureContext.Consumer;

export default FeatureContext;
